export default "__VITE_ASSET__BU6CH5rx__"